import { useJournalStore } from '../hooks/useJournalStore';
import type { WidgetProps } from './WidgetRegistry';

export function GoalFrameWidget(_props: WidgetProps) {
  const journal = useJournalStore((s) => s.activeJournal);
  if (!journal) return <div className="text-tower-muted text-sm p-3">No journal loaded</div>;

  const gf = journal.rootContinuation.goalFrame;

  return (
    <div className="p-3 space-y-2 text-sm">
      <div>
        <span className="text-tower-muted text-xs">Intent</span>
        <div className="text-tower-accent font-mono">{gf.intent}</div>
      </div>
      <div>
        <span className="text-tower-muted text-xs">Question</span>
        <div className="text-tower-text">{gf.question}</div>
      </div>
      {Object.keys(gf.bindings).length > 0 && (
        <div>
          <span className="text-tower-muted text-xs">Bindings</span>
          <div className="flex flex-wrap gap-1 mt-0.5">
            {Object.entries(gf.bindings).map(([k, v]) => (
              <span key={k} className="text-xs bg-tower-accent/10 text-tower-accent px-1.5 py-0.5 rounded">
                {k}: {String(v)}
              </span>
            ))}
          </div>
        </div>
      )}
      <div className="flex gap-3 text-xs text-tower-muted border-t border-tower-border pt-2">
        <span>Deliverable: <span className="text-tower-text">{gf.deliverable}</span></span>
        <span>Tools: <span className="text-tower-text">{gf.eligibleTools.length}</span></span>
      </div>
    </div>
  );
}
